import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTranslation } from 'react-i18next';

const SalesTrendChart = ({ data }) => {
    const { t } = useTranslation();
    const chartData = data?.data || [];
    if (chartData.length === 0) return null;

    const strings = t('salesAnalytics.charts.trend', { returnObjects: true });

    const xLabels = chartData.map(item =>
        new Date(item.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
    );
    const weightData = chartData.map(item => parseFloat(item.weight_tons) || 0);
    const orderData = chartData.map(item => item.order_count || 0);

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
                <div style={{ display: 'flex', gap: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{ width: 10, height: 10, borderRadius: 2, backgroundColor: '#3b82f6' }} />
                        <span style={{ fontSize: 12, color: '#6b7280' }}>{strings.weightTon}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{ width: 10, height: 10, borderRadius: 2, backgroundColor: '#a78bfa' }} />
                        <span style={{ fontSize: 12, color: '#6b7280' }}>{strings.orders}</span>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', height: 300, padding: '0 16px 16px' }}>
                <BarChart
                    series={[
                        { data: weightData, label: strings.weightTon, color: '#3b82f6', yAxisKey: 'weight' },
                        { data: orderData, label: strings.orders, color: '#a78bfa', yAxisKey: 'orders' },
                    ]}
                    xAxis={[{
                        data: xLabels, scaleType: 'band',
                        tickLabelStyle: { fontSize: 11, fill: '#9ca3af' },
                    }]}
                    yAxis={[
                        { id: 'weight', position: 'left', tickLabelStyle: { fontSize: 10, fill: '#9ca3af' } },
                        { id: 'orders', position: 'right', tickLabelStyle: { fontSize: 10, fill: '#9ca3af' } },
                    ]}
                    slotProps={{ legend: { hidden: true } }}
                    margin={{ top: 10, right: 50, bottom: 40, left: 55 }}
                    borderRadius={4}
                />
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 12px', borderBottom: '1px solid #f9fafb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default SalesTrendChart;
